module.exports = __webpack_public_path__ + "static/leaf-2-6792d20d111e949a2fd13887a79b6e05.png";